import { PropsWithChildren, ReactNode } from 'react';

import { Hint } from 'components';
import { Stack, Typography } from 'libs/ui';

import { ContentStyled } from './Section.styles';

export interface SectionProps extends PropsWithChildren {
  title: string;
  titleHint?: {
    title: ReactNode;
  };
  titleEndContent?: ReactNode;
}

export const Section = ({
  title,
  titleHint,
  titleEndContent,
  children,
}: SectionProps) => (
  <Stack spacing={24} spacingMobile={16}>
    <ContentStyled>
      <Stack alignItems="center" direction="row" spacing={8}>
        <Typography as="h3" variant="subtitleSemiBold" variantMobile="bodyBold">
          {title}
        </Typography>
        {titleHint && <Hint title={titleHint?.title} />}
      </Stack>
      {titleEndContent}
    </ContentStyled>

    {children}
  </Stack>
);
